import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';
import { LinkedFile, Product, SalesOrder, RecentInteractions, gridPageRequest } from '../model/common/common.model';
import { switchMap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SalesService {

  constructor(private httpClientService: HttpClientService) { }

  public autoSearchProduct(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.SALES.AUTOSEARCHPRODUCT}?searchText=${seachkey}`);
  }

  public autoSearchRawMaterialProduct(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.AUTOSEARCHRAWMATERIALPRODUCT}search?searchText=${seachkey}`);
  }

  public autoSearchCustomer(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.SALES.AUTOSEARCHCUSTOMERS}?searchText=${seachkey}`);
  }

  public autoSearchProjectBom(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPROJECT}?searchText=${seachkey}`);
  }


  public autoSearchProjectBomline(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPROJECTLINEITM}?searchText=${seachkey}`);
  }


  public autoSearchManufacturingProjectBom(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHMANUFACTURINGPROJECT}?searchText=${seachkey}`);
  }
  public SearchSalesOrder(seachkey: string, pageIndex?: number, pageSize?: number) {
    return this.httpClientService.get(`${CONFIG.SALES.SEARCH_SALESORDER}?searchText=${seachkey}`);
  }

  // public autogenerateSalesOrderNumber() {
  //   return this.httpClientService.get(CONFIG.SALES.AUTOGENERATE_SALESORDERNUMBER);
  // }

  public autogenerateSalesOrderNumber() {
    return this.httpClientService.get(CONFIG.CRM.AUTOGENERATE_SERVICEINVOICE);
  }

  public autogenerateQuoteNumber() {
    return this.httpClientService.get(CONFIG.SALES.AUTOGENERATE_SALESQUOTENUMBER);
  }

  public autogenerateOrderNumber() {
    return this.httpClientService.get(CONFIG.SALES.AUTOGENERATE_SALESORDERNUMBER);
  }

  public autogenerateInvoiceNumber() {
    return this.httpClientService.get(CONFIG.SALES.AUTOGENERATE_SALESINVOICENUMBER);
  }


  public getSalesOrderList(data: any) {
    return this.httpClientService.post(CONFIG.SALES.GET_SALESORDERLIST, data);
  }

  public createSalesOrder(data: SalesOrder) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESORDER}`, data);
  }

  public updateSalesOrder(data: SalesOrder) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_SALESORDER}`, data);
  }
  public updateSalesOrderNew(data: SalesOrder) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_SALESORDER_NEW}`, data);
  }

  public deleteSalesOrder(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_SALESORDER}`, data);
  }

  public createSalesOrderLineItem(data: Product) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESORDER_LINEITEM}`, data);
  }

  public updateSalesOrderLineItem(data: Product) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_SALESORDER_LINEITEM}`, data);
  }

  public getSalesOrderLineItem(data: any) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESORDER_LINEITEMS}?id=${data}`);
  }

  public deleteSalesOrderLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_SALESORDER_LINEITEM}`, data);
  }

  public checkOrderNumber(data: any) {
    return this.httpClientService.get(`${CONFIG.SALES.CHECK_SALESORDER_NUMBER}?salesOrderNumber=${data}`);
  }

  public getSalesOrderByStatus(value: string, data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.GET_SALESORDER_BYSTATUS}?status=${value}`, data);
  }

  public getInvoiceOrderStatus(value: string, data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.GET_INVOICEORDER_BYSTATUS}?status=${value}`, data);
  }
  public UpdateInvoiceBillStatus(data: any) {
    return this.httpClientService.post(CONFIG.SALES.UPDATE_INVOICEBILLSTATUS, data);
  }

  public createSalesOrderWithAR(data: SalesOrder) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESORDERWITHAR}`, data);
  }
  public createSalesOrderWithARNew(data: SalesOrder) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESORDERWITHARNEW}`, data);
  }


  //  mail end-points

  public SendMail(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.SEND_MAIL}`, data);
  }

  public SendSupportRequest(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.SEND_SUPPORT_MAIL}`, data);
  }

  public CreateSupportRequest(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SUPPORT_MAIL}`, data);
  }

  public getSalesOrderById(salesOrderId: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESORDER_BYID}?id=${salesOrderId}`);
  }

  public getSalesOrderBySalesOrderNo(salesOrderNo: string) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESORDER_BY_NUMBER}?number=${salesOrderNo}`);
  }
  public getSalesOrdersBySalesOrderNo(salesOrderNo: string) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESORDERS_BY_NUMBER}?number=${salesOrderNo}`);
  }
  public getSalesOrderLineItemById(SalesOrderLineItemId: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESORDERLINEITEM_BYID}?id=${SalesOrderLineItemId}`);
  }
  public getBOTransaction() {
    return this.httpClientService.post(`${CONFIG.SALES.GET_BO_TRANSACTION}`);
  }

  public searchBOTransaction(data: any) {
    const para = `TransactionNo=${data.TransactionNo}ShipToCustomerCode=${data.ShipToCustomerCode}&OrderDate${data.OrderDate}&WareHouseId=${data.WareHouseId}&CustomerId=${data.CustomerId}`;
    return this.httpClientService.post(`${CONFIG.SALES.GET_BO_TRANSACTION}`, data);
  }

  public getEmailTemplate(tenantId: string, templateName: string) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_EMAIL_TEMPLATE}/${tenantId}/${templateName}`);
  }

  // linked files

  public createLinkedFiles(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_LINKEDFILE}`, data);
  }

  public getLinkedFileOrderId(data: any) {
    return this.httpClientService.get(`${CONFIG.SALES.LINKEDFILEBYORDERID}?id=${data}`);
  }

  public updateLinkedFile(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_LINKEDFILE}`, data);
  }

  public getLinkedFileId(data: any) {
    return this.httpClientService.get(`${CONFIG.SALES.LINKEDFILEBYID}?id=${data}`);
  }

  public deleteLinkedFile(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_LINKEDFILE}`, data);
  }

  // Recent Interactions

  public createRecentInteractions(data: RecentInteractions) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_RECENTINTERACTIONS}`, data);
  }

  public getrecentInteractionsById(data: RecentInteractions) {
    return this.httpClientService.get(`${CONFIG.SALES.RECENTINTERACTIONSBYID}?id=${data}`);
  }

  public getrecentInteractionsByVendorNumber(data: RecentInteractions) {
    return this.httpClientService.get(`${CONFIG.SALES.RECENTINTERACTIONSBYVENDORNUMBER}?id=${data}`);
  }

  public getFilteredData(month: number, year: number, customerCode: any) {
    return this.httpClientService.get(`${CONFIG.SALES.GETFILTEREDDATA}?month=${month}&year=${year}&customerCode=${customerCode}`);
  }

  public getRecentInteractionsByCRM(data: RecentInteractions) {
    return this.httpClientService.get(`${CONFIG.SALES.GETRECENTINTERACTIONSBYCRM}?id=${data}`);
  }
  // public getOrder(salesOrderNo: string) {
  //   return this.httpClientService.get(
  //     `${CONFIG.SALES.GET_INVOICEORDER_NUMBER}?orderNumber=${salesOrderNo}`
  //   );
  // }
  public getInvoiceCustomerEmails() {
    return this.httpClientService.get(`${CONFIG.SALES.GET_INVOICE_CUSTOMER_EMAILS}`);
  }

  public createReminder(data: any) {
    return this.httpClientService.post(`${CONFIG.REMINDER.CREATE_REMINDER}`, data);
  }

  public getInvoiceReminders(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.REMINDER.GET_REMINDER, data);
  }
  public getBillReminders(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.REMINDER.GET_BILLREMINDER, data);
  }

  public getEmailTemplateById(templateId: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_EMAIL_TEMPLATE}/${templateId}`);
  }
  public getEmailTemplatesById(templateId: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_EMAIL_TEMPLATE_BY_ID}/${templateId}`);
  }
  public getEmailTemplateByName(templateName: string) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_EMAIL_TEMPLATE_BY_NAME}/${templateName}`);
  }
  public updateReminder(data: any) {
    return this.httpClientService.post(CONFIG.REMINDER.UPDATE_REMINDER, data);
  }
  public deleteReminder(data: any) {
    return this.httpClientService.post(CONFIG.REMINDER.DELETE_REMINDER, data);
  }
  public getReminderById(reminderId: number) {
    return this.httpClientService.get(`${CONFIG.REMINDER.GET_REMINDER_BY_ID}/${reminderId}`);
  }
  public sendActiveReminders() {
    return this.httpClientService.post(CONFIG.REMINDER.SEND_ACTIVE_REMINDERS, {});
  }
  public getInvoiceReminderData() {
    return this.httpClientService.get(CONFIG.SALES.GET_INVOICE_REMINDER_DATA);
  }
  public getBillReminderData() {
    return this.httpClientService.get(CONFIG.SALES.GET_BILL_REMINDER_DATA);
  }

  // Sales Return 

  public getInvoiceForSalesReturn(value: string, data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.GET_INVOICEORDER_FORSALESRETURN}?status=${value}`, data);
  }

  public createSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESRETURN}`, data);
  }

  public updateSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_SALESRETURN}`, data);
  }

  public getSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.GET_SALESRETURN}`, data);
  }

  public getSalesReturnById(id: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESRETURN_BYID}?id=${id}`);
  }

  public deleteSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_SALESRETURN}`, data);
  }

  public voidSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.VOID_SALESRETURN}`, data);
  }

  public refundSalesReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.REFUND_SALESRETURN}`, data);
  }

  public createSalesOrderReturnLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.CREATE_SALESRETURN_LINEITEM}`, data);
  }

  public updateSalesOrderReturnLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.UPDATE_SALESRETURN_LINEITEM}`, data);
  }

  public getSalesReturnLineItemById(id: number) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_SALESRETURN_LINEITEM_BYID}?id=${id}`);
  }

  public deleteSalesReturnLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_SALESRETURN_LINEITEM}`, data);
  }

  public searchSalesReturn(searchText: string) {
    return this.httpClientService.get(`${CONFIG.SALES.SEARCH_SALESRETURN}?searchText=${encodeURIComponent(searchText)}`);
  }

  public deleteInvoiceHeader(data: any) {
    return this.httpClientService.post(`${CONFIG.SALES.DELETE_SALESORDER}`, data);
  }

  public searchInvoice(searchKey: string) {
    return this.httpClientService.post(`${CONFIG.SALES.SEARCH_SALESORDER}`, { searchKey: searchKey });
  }

  public getAlreadyReturnedQty(salesOrderNumber: string) {
    return this.httpClientService.get(`${CONFIG.SALES.GET_ALREADY_RETURNED_QTY}?salesOrderNumber=${salesOrderNumber}`);
  }

  public autogenerateSalesReturnNumber() {
    return this.httpClientService.get(CONFIG.SALES.AUTOGENERATE_SALESRETURNSNUMBER);
  }

  public glPostSalesReturn(salesOrderReturnId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_SALES_RETURN}/${salesOrderReturnId}`, body);
  }

  public getGlEntriesForSalesReturn(salesOrderReturnId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_SALES_RETURN}/${salesOrderReturnId}`);
  }

  public glPostSalesInvoice(salesOrderId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_SALES_INVOICE}/${salesOrderId}`, body);
  }

  public getGlEntriesForSalesInvoice(salesOrderId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_SALES_INVOICE}/${salesOrderId}`);
  }

  public getCurrentFinancialYear() {
    return this.httpClientService.get(CONFIG.SALES.GET_FINICIALYEAR);
  }

  // public getFinancialYearByDate(date: any) {
  //   return this.httpClientService.get(`${CONFIG.SALES.GET_FINICIALYEAR_BYDATE}/${date}`);
  // }

  // getFinancialYearByDate(date: Date) {
  //   const formattedDate = date.toISOString();

  //   return this.httpClientService.get(
  //     `${CONFIG.SALES.GET_FINICIALYEAR_BYDATE}?date=${formattedDate}`
  //   );
  // }

  public getFinancialYearByDate(date: Date) {
    const formattedDate = date.toISOString().split('T')[0];
    return this.httpClientService.get(
      `${CONFIG.SALES.GET_FINICIALYEAR_BYDATE}?date=${formattedDate}`
    );
  }
}
